import { EMPTY_OBJECT, EMPTY_STRING } from '../../../../constants/common'

function getIconSvgProps(Icon) {
  if (!Icon?.render) {
    return EMPTY_OBJECT
  }

  const element = Icon.render(EMPTY_OBJECT, null)

  return element?.props ?? EMPTY_OBJECT
}

function getIconDataAttributes(Icon) {
  const props = getIconSvgProps(Icon)

  return Object.fromEntries(
    Object.entries(props).filter(([key]) => key.startsWith('data-'))
  )
}

function getIconSizes(Icon) {
  const data = getIconDataAttributes(Icon)

  return Object.entries(data)
    .filter(([key]) => key.startsWith('data-width-'))
    .map(([key]) => key.replace('data-width-', EMPTY_STRING))
}

export function preparedIconList() {
  const req = require.context('../../../../icons', false, /\.svg$/)

  return req.keys().map(path => {
    const Icon = req(path).default
    const name = path.replace('./', EMPTY_STRING).replace('.svg', EMPTY_STRING)

    return { Icon, name, sizes: getIconSizes(Icon) }
  })
}
